import type { ReactNode } from 'react';

// OS RÓTULOS QUE O CARBON TRAZ EM INGLÊS, em português. O Carbon não tem um provedor de idioma: cada
// componente recebe os dele por prop ("Close" do modal, "Clear search input" da busca, "Click to
// sort rows…" do cabeçalho, o ícone de cada aviso). Eles viram tooltip e são lidos pelo leitor de
// tela. `uiCarbon.test.ts` exige a prop em cada uso, e a vitrine é varrida atrás de inglês.

export const ROTULOS = {
  fechar: 'Fechar',
  fecharAviso: 'Fechar aviso',
  carregando: 'Carregando',
  limparBusca: 'Limpar busca',
  tirarFiltro: 'Tirar o filtro',
  caminho: 'Caminho',
  mostrarSenha: 'Mostrar senha',
  esconderSenha: 'Esconder senha',
  ligado: 'Ligado',
  desligado: 'Desligado',
  mesSeguinte: 'Mês seguinte',
  mesAnterior: 'Mês anterior',
} as const;

const DO_AVISO: Record<string, string> = {
  error: 'Erro',
  success: 'Sucesso',
  warning: 'Aviso',
  'warning-alt': 'Aviso',
  info: 'Informação',
  'info-square': 'Informação',
};

/** O nome do ícone de status de um aviso (`statusIconDescription`). */
export const rotuloDoAviso = (tipo?: string) => DO_AVISO[tipo ?? 'error'] ?? DO_AVISO.info;

const DA_LISTA: Record<string, string> = {
  'close.menu': 'Fechar lista',
  'open.menu': 'Abrir lista',
  'clear.all': 'Limpar a seleção',
  'clear.selection': 'Limpar a seleção',
};

/** `translateWithId` do `Dropdown`, do `ComboBox` e do `MultiSelect`. */
export const traduzirLista = (id: string) => DA_LISTA[id] ?? id;

const DO_PASSO: Record<string, string> = {
  'carbon.progress-step.complete': 'Concluída',
  'carbon.progress-step.incomplete': 'Não iniciada',
  'carbon.progress-step.current': 'Atual',
  'carbon.progress-step.invalid': 'Com erro',
};

/** `translateWithId` do `ProgressStep`: o estado de cada passo, para o leitor de tela. */
export const traduzirPasso = (id: string) => DO_PASSO[id] ?? id;

const textoDe = (n: ReactNode) => (typeof n === 'string' || typeof n === 'number' ? String(n) : '');

/** `translateWithId` da `DataTable`: o que o clique no cabeçalho ordenável vai fazer. */
export const traduzirTabela = (
  id: string,
  args?: { header?: ReactNode; sortDirection?: string; isSortHeader?: boolean },
): string => {
  if (id === 'carbon.table.header.icon.description') {
    const coluna = textoDe(args?.header);
    if (args?.isSortHeader && args.sortDirection === 'ASC') return `Ordenar por ${coluna}, em ordem decrescente`;
    if (args?.isSortHeader && args.sortDirection === 'DESC') return `Ordenar por ${coluna}, em ordem crescente`;
    return `Ordenar por ${coluna}`;
  }
  const outros: Record<string, string> = {
    'carbon.table.all.select': 'Selecionar todas as linhas',
    'carbon.table.all.unselect': 'Desmarcar todas as linhas',
    'carbon.table.row.select': 'Selecionar a linha',
    'carbon.table.row.unselect': 'Desmarcar a linha',
    'carbon.table.all.expand': 'Abrir todas as linhas',
    'carbon.table.all.collapse': 'Fechar todas as linhas',
    'carbon.table.row.expand': 'Abrir a linha',
    'carbon.table.row.collapse': 'Fechar a linha',
    'carbon.table.batch.cancel': 'Cancelar',
    'carbon.table.batch.selectAll': 'Selecionar tudo',
    'carbon.table.toolbar.search.label': 'Buscar na tabela',
    'carbon.table.toolbar.search.placeholder': 'Buscar',
  };
  return outros[id] ?? id;
};
